import { useState } from "react";
import { Sparkles } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../lib/i18n";

export default function AiSummary({ id }) {
  const { lang } = useLang();
  const [bullets, setBullets] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (bullets || loading) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/articles/${id}/ai-summary`);
      setBullets(data);
    } catch {
      setBullets({ hi: [], en: [] });
    }
    setLoading(false);
  };

  const list = bullets ? (lang === "hi" ? bullets.hi : bullets.en) : [];

  return (
    <div className="mt-8" data-testid="ai-summary">
      <button
        data-testid="ai-summary-button"
        onClick={load}
        disabled={loading}
        className="flex items-center gap-2 border-2 border-gold bg-gold-light/20 px-5 py-2.5 text-sm font-bold text-ink hover:bg-gold hover:text-deepgreen transition-colors disabled:opacity-60"
      >
        <Sparkles size={16} />
        {loading
          ? lang === "hi" ? "AI सारांश बन रहा है…" : "AI summary loading…"
          : lang === "hi" ? "AI सारांश देखें" : "View AI Summary"}
      </button>
      {bullets && (
        <div className="mt-4 border-l-4 border-gold bg-white p-5" data-testid="ai-summary-box">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold-accent mb-3">
            {lang === "hi" ? "Vainor AI • मुख्य बिंदु" : "Vainor AI • Key points"}
          </p>
          <ul className="space-y-2.5">
            {list.map((b, i) => (
              <li key={i} className="flex gap-3 text-sm md:text-base text-inkgray leading-relaxed">
                <span className="text-gold-accent font-bold shrink-0">◆</span>
                {b}
              </li>
            ))}
          </ul>
          {list.length === 0 && (
            <p className="text-sm text-muted-foreground">
              {lang === "hi" ? "सारांश अभी उपलब्ध नहीं" : "Summary unavailable right now"}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
